import { useState, useEffect } from 'react';
import { RowFields } from './Constants';

/*************/
/* Row Utils */
/*************/
export const rowContainsError = row => !!Object.values(RowFields).find(field => row[field.id] && (!!row[field.id].errMsg))

// ignore BillNumber field because the user cannot modify it, realistically that field shouldn't even have a displayError field
export const rowIsIncomplete = row => !!Object.values(RowFields).find(field => row[field.id] && !row[field.id].displayError && (field.id !== RowFields.BillNumber.id))

export function insertItem(array, index, obj) {
    let newArray = array.slice()
    newArray.splice(index, 0, obj)
    return newArray
}
  
export function removeItem(array, index) {
    let newArray = array.slice()
    newArray.splice(index, 1)
    return newArray
}

export function updateFieldObjectInArray(array, index, field, obj) {
    return array.map((item, idx) => {
        if (idx !== index) {
            return item;
        }

        return {
            ...item, 
            [field]: obj
        }
    })
}

// Returns true if a row has a single partial BELOW it
export function doesRowHavePartials(rowData, index) {
    const nextRow = rowData[index+1];
    const currRow = rowData[index];
    const currRowHasPartials = !!nextRow 
            && (nextRow.rowType === "partial")
            && (nextRow.billNumber.value === currRow.billNumber.value);
    return currRowHasPartials;
}

export function useDebounce(value, delay) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);
  
    useEffect(
      () => {
        // Update debounced value after delay
        const handler = setTimeout(() => {
          setDebouncedValue(value);
        }, delay);
  
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return () => {
          clearTimeout(handler);
        };
      },
      [value, delay] // Only re-call effect if value or delay changes
    );
  
    return debouncedValue;
  }
  